import WarningIcon from '@material-ui/icons/Warning';
import { COLORS } from 'src/constants/Color';

const Warning = () => (
  <WarningIcon style={{
    color: COLORS.red,
    marginRight: 0,
    marginLeft: 'auto',
    fontSize: '16px',
  }} />
);

export default Warning;
